import { Box, List } from '@mui/material';
import { NavSeparator } from './base';
import { NavFooter } from './footer/NavFooter';
import { SidenavHeader } from './header/SidenavHeader';
import { Props } from './Sidenav';
import { SidenavContextProvider } from './SidenavContext';
import { Drawer } from './SidenavDrawer';

export function SidenavP(p: Props) {
  const { auth, collapsed, timezone } = p;
  // Invert collapsed to open (MUI pattern uses open=true for expanded)
  const open = !collapsed;

  return (
    <Drawer variant="permanent" open={open}>
      <SidenavContextProvider collapsed={collapsed}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            paddingTop: { xs: '1.25rem', xl: '1.5rem' },
          }}
        >
          <SidenavHeader auth={auth} collapsed={collapsed} />
          <NavSeparator sx={{ my: 1 }} />
          <Box
            sx={{
              paddingTop: { xs: '0.5rem', xl: '1rem' },
              paddingBottom: { xs: '0.5rem', xl: '1rem' },
            }}
          >
            <List disablePadding>{p.children}</List>
          </Box>
          <NavFooter auth={auth} timezone={timezone} />
        </Box>
      </SidenavContextProvider>
    </Drawer>
  );
}
